module.exports = __webpack_public_path__ + "static/media/TAN-logo2.fcb08b6a.png";